import React, { useMemo, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import type { ComponentProps } from 'react';
import VoyageStatisticsPrint from './VoyageStatisticsPrint';
import { sharedPrintStyles, basePrintContainerStyle } from './printStyles';

type VoyageStatsPayload = ComponentProps<typeof VoyageStatisticsPrint>;

function decodePayload(params: URLSearchParams): VoyageStatsPayload | null {
  const payload = params.get('payload');
  if (!payload) return null;
  try {
    const decoded = atob(decodeURIComponent(payload));
    return JSON.parse(decoded) as VoyageStatsPayload;
  } catch (err) {
    console.error('Failed to decode voyage statistics payload', err);
    return null;
  }
}

const VoyageStatisticsPrintPage: React.FC = () => {
  const [params] = useSearchParams();
  const data = useMemo(() => decodePayload(params), [params]);

  useEffect(() => {
    console.log('VoyageStatisticsPrintPage mounted', { hasData: !!data });
  }, [data]);

  if (!data) {
    return (
      <div className="print-page" style={errorStyles}>
        <p>Missing or invalid print payload.</p>
      </div>
    );
  }

  return (
    <div className="print-page" style={pageStyle}>
      <style>{sharedPrintStyles}</style>
      <VoyageStatisticsPrint {...data} />
    </div>
  );
};

const pageStyle: React.CSSProperties = {
  ...basePrintContainerStyle,
  backgroundColor: '#fff',
  minHeight: '100vh',
  padding: 0,
};

const errorStyles: React.CSSProperties = {
  ...pageStyle,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '16px',
};

export default VoyageStatisticsPrintPage;


